export default {
  qrModal: {
    faulire: {
      title1: 'Activá tu cuenta para que',
    },
  },
}
